module.exports = __webpack_public_path__ + "img/labmem_icon_line.5bd937c7.png";